export const d1 = 
`

At this point, if you care about autodiff, you probably already know what derivatives are gradients are 
and what they mean. The usual technique to find derivatives is by hand, using the primitive rules for 
differentiation.

`.trim();

//Insert diagram of hand differenetiation


export const d2 = 
`

However, this obviously can't work when you are working with code. How do you tell the computer to 
differentiate a function? It should clearly be possible, since when you do it by hand, you too are just 
following a set of rules. We need a way to tell the computer to follow this set of rules, and that is 
_precisely_ what autodiff does at its heart.

`.trim();


export const d3 = 
`
Autodiff has _[many, many](https://jax.readthedocs.io/en/latest/notebooks/autodiff_cookbook.html)_ different variations. The one most commonly used and referred to when discussing 
autodiff is **Reverse mode autodiff**, which allows you to find the entries of the Jacobian matrix row wise. Woah Woah, what is a Jacobian?

The Jacobian matrix, defined for a multivariate function is a matrix whose entries are partial derivatives 
of every output scalar with every input scalar.

`.trim();


// Diagram of jacobian

export const d4 = 
`
In general, when talking about mutivariate functions, we discuss about its Jacobian matrix. In this post, we are gonna focus 
only on the reverse mode version of autodiff, which is mainly what is used in Deep learning. That being said, there are many libraries that 
allow you to also find this matrix directly. (I recommend going through [JAX](https://jax.readthedocs.io/en/latest/notebooks/autodiff_cookbook.html) docs, which are an excellent source for more digestible info on this topic).

`.trim();
